<template>
  <sub-page :title="title">
    <div class="case-page">
      <div class="tabs">
        <div
          v-for="(tab, idx) in tabs"
          :key="idx"
          class="tab-item"
          :class="{ active: activeTab === idx }"
          @click="activeTab = idx"
        >
          {{ tab.name }}({{ tab.count }})
        </div>
      </div>
      <div class="search-box">
        <svg viewBox="0 0 24 24" class="search-icon"><circle cx="11" cy="11" r="7" fill="none" stroke="#969799" stroke-width="2"/><path d="M16 16 L21 21" stroke="#969799" stroke-width="2" stroke-linecap="round"/></svg>
        <input type="text" placeholder="请输入办件业务关键词" class="search-input" />
      </div>
      <div class="notice">
        <svg viewBox="0 0 24 24" class="notice-icon"><circle cx="12" cy="12" r="10" fill="none" stroke="#f28100" stroke-width="2"/><path d="M12 8 L12 13" stroke="#f28100" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="17" r="1" fill="#f28100"/></svg>
        <span>以下为等待您提交或处理的业务；部分业务移动端无法办理，需前往网上办事服务大厅（https://rs.jshrss.jiangsu.gov.cn）"我的办件"中处理。</span>
      </div>
      <div class="empty-state">
        <svg viewBox="0 0 24 24" class="empty-icon"><path d="M14 2 L6 2 Q4 2 4 4 L4 20 Q4 22 6 22 L18 22 Q20 22 20 20 L20 8 Z M14 2 L14 8 L20 8" fill="none" stroke="#c8c9cc" stroke-width="1.5" stroke-linejoin="round"/><path d="M9 12 L15 12 M9 16 L13 16" stroke="#c8c9cc" stroke-width="1.5" stroke-linecap="round"/></svg>
        <div class="empty-text">没有办件</div>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'CaseList',
  components: { SubPage },
  data() {
    return {
      title: '办件',
      activeTab: 0,
      tabs: [
        { name: '待提交', count: 0 },
        { name: '办理中', count: 0 },
        { name: '已办结', count: 5 },
        { name: '待评价', count: 0 }
      ]
    }
  }
}
</script>

<style scoped>
.case-page {
  background: #F3F8FB;
  min-height: 100%;
}
.tabs {
  display: flex;
  background: #fff;
  border-bottom: 1px solid #ebebeb;
}
.tab-item {
  flex: 1;
  text-align: center;
  padding: calc(24 * var(--w)) 0;
  font-size: calc(32 * var(--w));
  color: #646566;
  cursor: pointer;
  position: relative;
}
.tab-item.active {
  color: #323233;
  font-weight: 500;
}
.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: calc(48 * var(--w));
  height: calc(4 * var(--w));
  background: #2E8CF6;
  border-radius: calc(2 * var(--w));
}
.search-box {
  display: flex;
  align-items: center;
  background: #fff;
  margin: calc(24 * var(--w)) calc(32 * var(--w));
  padding: 0 calc(24 * var(--w));
  height: calc(72 * var(--w));
  border-radius: calc(36 * var(--w));
  gap: calc(16 * var(--w));
}
.search-icon {
  width: calc(32 * var(--w));
  height: calc(32 * var(--w));
  flex-shrink: 0;
}
.search-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: calc(28 * var(--w));
  color: #323233;
  background: transparent;
}
.search-input::placeholder {
  color: #969799;
}
.notice {
  display: flex;
  align-items: flex-start;
  background: #fff;
  margin: 0 calc(32 * var(--w));
  padding: calc(24 * var(--w));
  border-radius: calc(8 * var(--w));
  gap: calc(16 * var(--w));
  font-size: calc(26 * var(--w));
  color: #f28100;
  line-height: 1.6;
}
.notice-icon {
  width: calc(36 * var(--w));
  height: calc(36 * var(--w));
  flex-shrink: 0;
  margin-top: calc(2 * var(--w));
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: calc(120 * var(--w));
  gap: calc(32 * var(--w));
}
.empty-icon {
  width: calc(200 * var(--w));
  height: calc(200 * var(--w));
}
.empty-text {
  font-size: calc(32 * var(--w));
  color: #969799;
}
</style>



// WEBPACK FOOTER //
// src/pages/CaseList.vue